export default "/048cb1f2b29308e18768c65cfd51e426596a830c/aadf7e204ac3ecb8628e2b693a3c4a40.svg";